import React from 'react';
import { PrimaryButton } from '../Button';
import {
  StyledErrorState,
  ErrorStateContent,
  ErrorStateIcon,
  ErrorStateTitle,
  ErrorStateMessage,
  ErrorStateActions,
} from './ErrorStateStyles';

interface Props {
  title?: string;
  message?: string;
  onRetry?(): void;
}

export const ErrorState: React.FC<Props> = ({
  title = 'Oops!',
  message = 'Something went wrong!',
  onRetry,
}) => {
  return (
    <StyledErrorState>
      <ErrorStateIcon className="fal fa-exclamation-circle" />
      <ErrorStateContent>
        <ErrorStateTitle>{title}</ErrorStateTitle>
        <ErrorStateMessage>{message}</ErrorStateMessage>
      </ErrorStateContent>

      {!!onRetry && (
        <ErrorStateActions>
          <PrimaryButton type="button" onClick={onRetry} style={{ minWidth: 160 }}>
            Try Again
          </PrimaryButton>
        </ErrorStateActions>
      )}
    </StyledErrorState>
  );
};
